import React from 'react'
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { AlertJsMessage } from './../../../helpers.js'

export default class OneRm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rmChecked: false,
      wpChecked: false,
      rpeChecked: false
    }
  }

  componentDidMount() {
    if (this.props.rm && this.props.rm > 0) this.setState({ rmChecked: true });
    if (this.props.wp && this.props.wp > 0) this.setState({ wpChecked: true });
    if (this.props.rpe && this.props.rpe > 0) this.setState({ rpeChecked: true });
  }

  handleCheckChange = event => {
    const { checked, name } = event.target;
    const { changeField } = this.props;
    if (name === 'wpChecked') {
      if (this.state.rmChecked) {
        AlertJsMessage('Please uncheck % of 1 Rep Max to add Weight prescription');
        return;
      } else {
        if (this.state.rpeChecked) {
          AlertJsMessage('Please uncheck RPE to add Weight prescription');
          return;
        } else {
          !checked && changeField('wp', '')
          this.setState({ [name]: checked });
        }
      }
    }
    if (name === 'rpeChecked') {
      if (this.state.wpChecked) {
        AlertJsMessage('Please uncheck Weight prescription to add RPE');
        return;
      } else {
        if (this.state.rmChecked) {
          AlertJsMessage('Please uncheck % of 1 Rep Max to add RPE');
          return;
        } else {
          !checked && changeField('rpe', '')
          this.setState({ [name]: checked });
        }
      }
    }
    if (name === 'rmChecked') {
      if (this.state.wpChecked) {
        AlertJsMessage('Please uncheck Weight prescription to add % of 1 Rep Max');
        return;
      } else {
        if (this.state.rpeChecked) {
          AlertJsMessage('Please uncheck RPE to add % of 1 Rep Max');
          return;
        } else {
          !checked && changeField('rm', '');
          this.setState({ [name]: checked });
        }
      }
    }
  }

  render() {
    const { rm, wp, rpe, changeField } = this.props;
    const { rmChecked, wpChecked, rpeChecked } = this.state;
    return (
      <div
        className="additionalOptionItem"
      >
        <div style={{ width: '5%', marginLeft: 15 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={rmChecked}
                name="rmChecked"
                onChange={this.handleCheckChange}
              />
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={rpeChecked}
                name="rpeChecked"
                onChange={this.handleCheckChange}
              />
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={wpChecked}
                name="wpChecked"
                onChange={this.handleCheckChange}
              />
            }
          />
        </div>
        <div style={{ width: '95%' }}>
          {
            rmChecked ? (
              <TextField
                style={{ marginBottom: 0, width: 175 }}
                label={`% of 1 Rep Max`}
                value={rm}
                onChange={(e) => changeField('rm', e.target.value)}
                margin="dense"
                variant="outlined"
                type="text"
                inputProps={{ maxLength: 5 }}
              />
            ) : (
                <p style={{ paddingBottom: 24 }}>
                  <b>% of 1 Rep Max:</b>
                  <span className="italics"> Select when you want this exercise to be performed as a percentage of the 1 rep max.
                  </span>
                </p>
              )
          }

        {
            rpeChecked ? (
              <TextField
                style={{ marginBottom: 0, width: 200 }}
                label={`Enter RPE`}
                value={rpe}
                onChange={(e) => changeField('rpe', e.target.value)}
                margin="dense"
                variant="outlined"
                type="text"
                inputProps={{ maxLength: 5 }}
              />
            ) : (
                <p style={{ paddingTop: 0,     paddingBottom: 12 }}>
                  <b>RPE:</b>
                  <span className="italics"> Select when you want to prescribe rate of perceived exertion.</span>
                </p>
              )
          }

          {
            wpChecked ? (
              <TextField
                style={{ marginBottom: 0, width: 200 }}
                label={`Enter number of pounds`}
                value={wp}
                onChange={(e) => changeField('wp', e.target.value)}
                margin="dense"
                variant="outlined"
                type="text"
                inputProps={{ maxLength: 5 }}
              />
            ) : (
                <p style={{ paddingTop: 12 }}>
                  <b>Weight Prescription:</b>
                  <span className="italics"> Select when you want to prescribe a precise weight for this exercise.</span>
                </p>
              )
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workouts/inputs/OneRM.js